import React from 'react';
import { Sparkles } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import '../styles/ReportsHeader.css';

const ReportsHeader = () => {
  return (
    <div className="reports-header">
      <div className="reports-header-content">
        <div className="reports-header-title">
          <Sparkles size={32} className="reports-header-icon" />
          <div>
            <h1>
              <FormattedMessage id="AiReports" defaultMessage="Informes IA" />
            </h1>
            <p className="reports-header-subtitle">
              Analizá, consultá y generá informes técnicos con inteligencia artificial. Iterá sobre los análisis para profundizar en los datos.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsHeader;
